import { QueryProvider } from "@msuite/ui/query";
import type { PropsWithChildren } from "react";
import { authClient } from "@/api/auth";

export function QueryProviderWrapper({ children }: PropsWithChildren) {
	const auth = authClient.useSession();

	/** Computed */
	// The persisted cache belongs to one user in one organisation; a copy written under another
	// organisation — a switch made in another tab — is thrown away rather than rehydrated.
	const userId = auth.data?.user?.id;
	const buster = userId ? `${userId}:${auth.data?.session?.activeOrganizationId ?? ""}` : userId;

	/** Render */
	return <QueryProvider buster={buster}>{children}</QueryProvider>;
}
